import type { LocalRecord } from './database';
import type { SyncEntityType, SyncPayload } from '../types/sync';

export function selectPayloads<T extends SyncPayload>(
  records: LocalRecord[],
  entityType: SyncEntityType,
) {
  return records
    .filter(record => record.entityType === entityType)
    .map(record => record.payload as T);
}

export function selectFirstPayload<T extends SyncPayload>(
  records: LocalRecord[],
  entityType: SyncEntityType,
) {
  return selectPayloads<T>(records, entityType)[0];
}
